import fetch from 'utils/fetch';
import { UserInfo } from 'types';

export async function postUser(user: UserInfo) {
  const response = await fetch('/api/user/edit-personal-info', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(user),
  });

  return response.ok;
}

export async function syncWhoIs() {
  const response = await fetch('/api/user/sync-whois', { method: 'PUT' });

  return response.ok;
}
